module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.access) ? _c('router-link', {
    attrs: {
      "to": _vm.curLink
    }
  }, [(_vm.fontawesomeicon) ? _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.fontawesomeicon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.flagicon !== null && _vm.flagicon !== undefined && _vm.flagicon !== false) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagicon
  }) : _vm._e(), _vm._v(" "), (_vm.imageBefore !== null && _vm.imageBefore !== undefined && _vm.imageBefore !== false) ? _c('img', {
    staticClass: "link-image",
    attrs: {
      "src": _vm.imageBefore
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curText.length === 1) ? [_vm._v(_vm._s(_vm._f("ftc")(_vm.curText[0])))] : _vm._l((_vm.curText), function(t, ix) {
    return [(t === '<br>') ? _c('br', {
      key: ix
    }) : [_vm._v(_vm._s(_vm._f("ftc")(t)))]]
  })], 2) : _c('span', [(_vm.fontawesomeicon) ? _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.fontawesomeicon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.flagicon !== null && _vm.flagicon !== undefined && _vm.flagicon !== false) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagicon
  }) : _vm._e(), _vm._v(" "), (_vm.imageBefore !== null && _vm.imageBefore !== undefined && _vm.imageBefore !== false) ? _c('img', {
    staticClass: "link-image",
    attrs: {
      "src": _vm.imageBefore
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curText.length === 1) ? [_vm._v(_vm._s(_vm._f("ftc")(_vm.curText[0])))] : _vm._l((_vm.curText), function(t, ix) {
    return [(t === '<br>') ? _c('br', {
      key: ix
    }) : [_vm._v(_vm._s(_vm._f("ftc")(t)))]]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a474f9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/link.vue
// module id = 750
// module chunks = 0